const MARGIN_LOW = -10;
const ZERO = 0;

function snapCropToBounds({ x, y, width, height }) {
  [x, y, width, height] = [x, y, width, height].map((v) => (MARGIN_LOW < v && v < ZERO ? ZERO : v)); // if any negative values are greater than -10 then snap them to zero

  return { x, y, width, height };
}

export default snapCropToBounds;
